'use client'

import { RichText } from '@/frontend/components/ui/content/rich-text'

export const AccordionItem = ({ item }) => {
  const openItem = (e) => {
    const tab = e.currentTarget
    const item = e.currentTarget.parentElement
    const content = tab.nextElementSibling
    const isOpen = tab.getAttribute('aria-expanded') === 'true'

    tab.setAttribute('aria-expanded', !isOpen)
    item.classList.toggle('open')
    content.setAttribute('aria-hidden', isOpen)
  }

  const ItemHead = ({ item }) => (
    <button
      onClick={openItem}
      id={`accordion-item-${item.id}`}
      className="accordion-button"
      aria-controls={`accordion-content-${item.id}`}
      aria-expanded="false"
    >
      <span className="accordion-button-text">{item.heading}</span>
      <span className="accordion-button-icon">
        <svg
          className="accordion-title-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z" />
        </svg>
      </span>
    </button>
  )

  const ItemContent = ({ item }) => (
    <div
      id={`accordion-content-${item.id}`}
      className="accordion-content"
      role="tabpanel"
      aria-labelledby={`accordion-item-${item.id}`}
      aria-hidden="true"
    >
      <div className="copy-text">
        <RichText content={item.description} />
      </div>
    </div>
  )

  return (
    <li className="accordion-item">
      <ItemHead item={item} />
      <ItemContent item={item} />
    </li>
  )
}

export default AccordionItem
